module.exports = __webpack_public_path__ + "static/media/carminda.105201fd.jpeg";